import { useBookingFlow } from "../../context/use-booking-flow";
import { BookingCreatePage } from "../booking-create-page/booking-create-page";
import { BookingSummary } from "../booking-summary/booking-summary";
import { BookingUpsell } from "../booking-upsell/booking-upsell";
import { BookingLoading } from "../booking-loading/booking-loading";
import { BookingResult } from "../booking-result/booking-result";
import {
  DefaultFlowStep,
  UpsellFlowStep,
} from "../../context/use-booking-flow/use-booking-flow.types";

const StepComponents = {
  // Default Flow
  [DefaultFlowStep.CREATE]: BookingCreatePage,
  [DefaultFlowStep.SUMMARY]: BookingSummary,
  [DefaultFlowStep.LOADING]: BookingLoading,
  [DefaultFlowStep.RESULT]: BookingResult,
  // Upsell Flow
  [UpsellFlowStep.CREATE]: BookingCreatePage,
  [UpsellFlowStep.UPSELL]: BookingUpsell,
  [UpsellFlowStep.SUMMARY]: BookingSummary,
  [UpsellFlowStep.LOADING]: BookingLoading,
  [UpsellFlowStep.RESULT]: BookingResult,
} as const;

export const BookingFlow = () => {
  const { currentStep } = useBookingFlow();

  const Component = StepComponents[currentStep as keyof typeof StepComponents];

  if (!Component) {
    return <BookingCreatePage />;
  }

  return <Component />;
};
